export interface ModuleDefinition {
  key: string;
  label: string;
  description: string;
  route: string;
  iconBg: string;
  iconColor: string;
}

export const MODULES: ModuleDefinition[] = [
  {
    key: 'organization',
    label: 'Organization',
    description: 'Organization management',
    route: 'app/organization',
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    key: 'inventory',
    label: 'Inventory',
    description: 'Manage stock, warehouses, items and transfers',
    route: 'app/inventory',
    iconBg: 'bg-blue-50',
    iconColor: 'text-blue-600',
  },
  {
    key: 'crm',
    label: 'CRM',
    description: 'Leads, opportunities and customer management',
    route: 'app/crm',
    iconBg: 'bg-teal-50',
    iconColor: 'text-teal-600',
  },

  {
    key: 'installment',
    label: 'Installment',
    description: 'Installment management',
    route: 'app/installment',
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    key: 'sales',
    label: 'Sales',
    description: 'Sales management',
    route: 'app/sales',
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    key: 'procurement',
    label: 'Procurement',
    description: 'Procurement management',
    route: 'app/procurement',
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    key: 'finance',
    label: 'Finance',
    description: 'Finance management',
    route: 'app/finance',
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    key: 'logistics',
    label: 'Logistics',
    description: 'Logistics management',
    route: 'app/logistics',
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    key: 'hq',
    label: 'HQ',
    description: 'HQ management',
    route: 'app/hq',
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
  {
    key: 'maintenance',
    label: 'Maintenance',
    description: 'Maintenance management',
    route: 'app/maintenance',
    iconBg: 'bg-purple-50',
    iconColor: 'text-purple-600',
  },
];
